<template>
    <div class=""  >
        
    
    <div class="withPopupDiv">    
        <iframe :key="iframeKey" :src="iframe_url" v-if="iframe_url" ref="myIframe"  @load="iframeLoaded"></iframe> 
        <div class="popupDiv" v-if="show_pop">
            <get_coin v-if="show_pop=='get_coin'" @closed="show_pop = $event"/>
             <Account v-if="show_pop=='get_account'" @closed="show_pop = $event"/>
        </div>  
    </div>
    
        <!-- <div class="whiteBgSec_1">
            <h2 class="text-center">Ready to Create?</h2>
            <p class="text-center subHeading">Type your vision below, and let our <br> AI Design Tool do the rest!</p>
            <div class="rdyToCrtBxes">
                <div class="row">
                    <div class="col-md-4">
                        <article class="bg_1">
                            <p>Modern kitchen with white marble counters, black cabinets, and a large island.</p>
                        </article>
                    </div>
                    <div class="col-md-4">
                        <article class="bg_2">
                            <p>Spa-like bathroom with stone tiles, freestanding tub, and warm lighting.</p>
                        </article>
                    </div>
                    <div class="col-md-4">
                        <article class="bg_3">
                            <p>Poolside lounge with cushioned sofas, coffee table, and tropical plants.</p>
                        </article>
                    </div>
                    <div class="col-md-12">
                        <article class="hideBefore">
                            <div class="row align-self-lg-stretch align-items-center">
                                <div class="col-12"><textarea name="" id="" placeholder="Type your vision..."></textarea></div>
                                <div class="col-md-8">
                                    <p class="lightGrey m-0">Tip: Good prompt contains a room type, furniture/color theme</p>
                                </div>
                                <div class="col-md-4 text-end">
                                    <button class="gradientBtn_1">Create</button>
                                </div>
                            </div>
                        </article>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
    </template>
     
    
    <script>
    import { mapActions, mapGetters } from "vuex";
    import axios from "axios";  
import { param } from "jquery";
    export default {  
        name:'ReadytoCreate',
        data() {
            return {
                iframe_url:'',
                iframeMessage: "",
                show_pop:'',   
                mainloader:'' ,    
                iframeKey: 0
      
            };
        },
        components: {
            get_coin: () => import('./GetCoinHomeowwner.vue'),
            Account: () => import('./Account.vue'),
        },
        watch: {
            Aiuser: {
                    handler(items) {
                        if (items){
                            axios
                            .get("/api/AI/user_token/AI-user/" + items.id, {params: {
                                        gtype:'iframe'
                                        }} )
                            .then((res) => {  
                                
                                if(res.data.success){
                                this.iframe_url=res.data.data
                                }else{ 
                                    //this.$router.push('/design-ai/account');      
                                }
                            });
                        }else{
                            //this.$router.push('/design-ai/login');
                        }
                             
                    },
                    immediate: true,
                    deep: true
                }, 
             },
        computed: {
            ...mapGetters("auth", ["user"]),
            ...mapGetters("Aiauth", ["Aiuser"]),
            ...mapGetters("Common", ["Setting"]),
            ...mapGetters({ 
                showroomId: "Common/MyItem", 
            }),
            ...mapGetters(["errors"]),
        },
        methods: {
            iframeLoaded() {
            // this.mainloader.hide()
            },
            postMessageFunction(event) {
          /* if (event.origin !== "https://your-iframe-origin.com") {
            console.warn("Untrusted origin:", event.origin);
            return;
          } */
          // Handle the message
          const message = event.data;
         // console.log("Message received from iframe:", message);
    
          if (message.type === "click:get-coins") {
                this.show_pop='get_coin'
          }
    
          if (message.type === "click:my-account") {
            this.show_pop='get_account'
            }
    
          // Example: Handle specific message types
          if (message.type === "click:my-design") { 
            this.iframeMessage = message.content; // Update Vue data
          }
        },
    
        },
        
    
        mounted() {
            this.$root.$on('reload_iframe', (x) => {
                if(x){
                    this.iframeKey += 1; 
                }
            })
    
            //this.mainloader=this.$loading.show({ loader: 'dots' })  ;
            // Add the event listener
            window.addEventListener("message", this.postMessageFunction, true);
        },
        beforeDestroy() {
            // Remove the event listener
            window.removeEventListener("message", this.postMessageFunction, true);
            //this.mainloader.hide()
        },
    
        beforeCreate(){
            //AIauthToken
           let AIauthToken= localStorage.getItem("AIauthToken");
           if (AIauthToken != null && AIauthToken.length > 10 &&
            typeof AIauthToken != 'undefined'
        ) {
            axios.get("/api/AI/user_token/AI-user/0", {params: {
                                        gtype:'iframe'
                                        }} )
                .then((res) => {                              
                    if(res.data.success){
                    this.iframe_url=res.data.data
                    }else{ 
                        this.$router.push('/design-ai/welcome');  
                    }
                });
        } else {
            this.$router.push('/design-ai/welcome');
        }
           
        }
         
        
    };
    
    </script>
     
     <style  >
     body div.modal-backdrop.fade.show{
        display: none !important;
     }
     </style>